import React from 'react';
import { Button, Group, Text } from '@mantine/core';
import {
  PermissionRestrictedTooltip,
  PERMISSION_RESTRICTED_MESSAGE,
} from '../../../permissions/scheduler';

export interface TaskDetailsFormActionsProps {
  isDirty: boolean;
  saving?: boolean;
  onSave: () => void;
  onCancel: () => void;
  /** Match parent surface (drawer uses --app-drawer-surface). */
  surfaceBackground?: string;
  /** When false, Save/Cancel match Save-to-Server mutate gating. */
  canMutate?: boolean;
}

export function TaskDetailsFormActions({
  isDirty,
  saving = false,
  onSave,
  onCancel,
  surfaceBackground = 'var(--mantine-color-body)',
  canMutate = true,
}: TaskDetailsFormActionsProps) {
  const saveDisabled = !canMutate || !isDirty || saving;
  const cancelDisabled = !canMutate || !isDirty || saving;

  return (
    <Group
      justify="space-between"
      align="center"
      gap="sm"
      wrap="nowrap"
      style={{
        flexShrink: 0,
        width: '100%',
        padding: '10px 16px',
        borderTop: '1px solid var(--mantine-color-default-border)',
        background: surfaceBackground,
        boxShadow: '0 -4px 12px rgba(15, 23, 42, 0.06)',
      }}
    >
      <Text size="xs" c={isDirty ? 'orange' : 'dimmed'} style={{ flex: 1, minWidth: 0 }}>
        {!canMutate
          ? PERMISSION_RESTRICTED_MESSAGE
          : saving
            ? 'Saving changes…'
            : isDirty
              ? 'Unsaved changes'
              : 'No pending changes'}
      </Text>
      <Group gap="sm" wrap="nowrap" style={{ flexShrink: 0 }}>
        <PermissionRestrictedTooltip restricted={!canMutate}>
          <Button variant="default" size="sm" onClick={onCancel} disabled={cancelDisabled}>
            Cancel
          </Button>
        </PermissionRestrictedTooltip>
        <PermissionRestrictedTooltip restricted={!canMutate}>
          <Button
            variant="filled"
            size="sm"
            onClick={onSave}
            disabled={saveDisabled}
            styles={
              saving
                ? {
                    root: {
                      opacity: 0.65,
                      cursor: 'not-allowed',
                    },
                  }
                : undefined
            }
          >
            {saving ? 'Saving..' : 'Save changes'}
          </Button>
        </PermissionRestrictedTooltip>
      </Group>
    </Group>
  );
}
